import React, { useState } from "react";
import Footer from "../components/Footer";
import LandingSection from "../components/LandingSection";
import Header from "../components/Header";
import { Link } from "react-router-dom";
import ActionButton from "../utils/ActionButton";
import ActionButton1 from "../utils/ActionButton1";
import axios from "axios";
import config from "../config/config.json";

const SupportForm2 = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        linkedIn: "",
        statement: "",
    });

    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState("");
    const [messageType, setMessageType] = useState("success");

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // console.log("Form Submitted:", formData);
        setIsSubmitting(true);
        setSubmitMessage("");

        const payload = {
            name: formData.name,
            email: formData.email,
            message: formData.statement,
            linkedin_url: formData.linkedIn,
        };

        try {
            const response = await axios.post(
                `${config.APP_URL}/sponsor/sponsor-request`,
                payload
            );
            // console.log("request:", response);
            setMessageType("success");
            setSubmitMessage("Your support statement has been submitted successfully!");
            setFormData({ name: "", email: "", linkedIn: "", statement: "" });

            // Hide message after 10 seconds
            setTimeout(() => {
                setSubmitMessage("");
            }, 10000);
        } catch (error) {
            console.error("API Error:", error);
            setMessageType("error");
            setSubmitMessage("Failed to submit your support. Please try again.");
        } finally {
            setIsSubmitting(false);
        }
    };
    // 

    return (
        <>
            <Header />

            <div className="bg-white py-16 px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto mt-24">
                {/* Page Heading */}
                <div className="mb-12 text-center">
                    <h2 className="text-4xl font-extrabold text-gray-900 mb-2">UTahData is looking for your Support</h2>
                    <p className="text-lg text-gray-600 max-w-3xl mx-auto">
                        For UTahData.org by your precious and kind words. Join other supporters and help us build a portal thats an innovative one-stop-shop for Utah related information.
                    </p>
                </div>

                {/* Intro Section */}
                <div className="rounded-xl shadow-lg p-6 sm:p-10 mb-12">
                    <h3 className="text-2xl font-semibold text-gray-800 mb-4 text-left">👋 Greetings!</h3>
                    <p className="text-gray-700 mb-3 text-left">
                        Thanks in advance for your support 🙏 For <strong>UTahData.org!</strong>
                    </p>
                    <p className="text-gray-600 mb-4 text-left">
                        At UTahData, our objective is to build a one-stop shop for all interesting data related to Utah in one place with an intent to make Utah look good!
                    </p>

                    <div className="flex flex-col sm:flex-row justify-around gap-4 mb-4">
                        <Link to="/founders-note"  >
                            <ActionButton1 data="Founder's Note" />
                        </Link>
                        <Link to="/faq">
                            <ActionButton1 data="Frequently Asked Questions" />
                        </Link>
                    </div>

                    <p className="text-gray-700 text-left">
                        You have been invited to write a Statement of Support for UTahData. We will take your statement and, along with your LinkedIn profile,
                        post it on our page on UTahData called <strong>“Supporters and Sponsors”</strong>.
                    </p>
                </div>


                {/* Form Section */}
                <form onSubmit={handleSubmit} className="space-y-6 bg-white p-6 sm:p-10 rounded-xl shadow-lg">
                    <h2 className="text-2xl font-semibold text-gray-800 mb-4 text-left">
                        Please submit the following information:
                    </h2>
                    <div>
                        <label htmlFor="name" className="block text-sm font-medium text-gray-700">Name:</label>
                        <input
                            type="text"
                            name="name"
                            id="name"
                            required
                            value={formData.name}
                            onChange={handleChange}
                            className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Enter your full name"
                        />
                    </div>

                    <div>
                        <label htmlFor="email" className="block text-sm font-medium text-gray-700">Email:</label>
                        <input
                            type="email"
                            name="email"
                            id="email"
                            required
                            value={formData.email}
                            onChange={handleChange}
                            className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Enter your email address"
                        />
                    </div>


                    <div>
                        <label htmlFor="linkedIn" className="block text-sm font-medium text-gray-700">LinkedIn:</label>
                        <input
                            type="url"
                            name="linkedIn"
                            id="linkedIn"
                            required
                            value={formData.linkedIn}
                            onChange={handleChange}
                            className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="https://linkedin.com/in/yourprofile"
                        />
                    </div>

                    <div>
                        <label htmlFor="statement" className="block text-sm font-medium text-gray-700">Submit your Statement here:</label>
                        <textarea
                            name="statement"
                            id="statement"
                            rows="5"
                            required
                            value={formData.statement}
                            onChange={handleChange}
                            className="mt-1 block w-full rounded-md border border-gray-300 shadow-sm p-3 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            placeholder="Write your statement here..."
                        />
                    </div>

                    {submitMessage && (
                        <div className={`text-center text-sm text-green-600 font-medium mt-2 ${messageType === "success" ? "text-green-600" : "text-red-600"
                            }`} >
                            {submitMessage}
                        </div>
                    )}

                    <div className="text-center">
                        <button
                            type="submit"
                            disabled={isSubmitting}
                            className="inline-block w-full sm:w-auto bg-blue-600 hover:bg-blue-700 text-white font-semibold px-6 py-3 rounded-md shadow-sm transition-all duration-200"
                        >
                            {isSubmitting ? "Submitting..." : "Submit Statement"}
                        </button>
                    </div>
                </form >
            </div >



            <Footer />
        </>
    );
};

export default SupportForm2;
